/**
 * Types for the Clients module (P10 — Listado de Clientes)
 * Los tipos principales del perfil financiero vienen de scoring.types.ts (CreditProfile).
 * Aquí solo quedan constantes de filtrado propias del módulo Clientes.
 */

export const CLIENT_ELIGIBILITY_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'YES', label: 'Elegible' },
  { value: 'NO', label: 'No elegible' },
  { value: 'PENDING', label: 'Pendiente' },
] as const;
